<div class="max-w-full">
  <div class="flex justify-between items-center mb-3">
    <h1 class="text-2xl font-semibold text-gray-900">Usuarios</h1>
  </div>

  <div class="flex justify-end items-center mb-6">
    <button
      class="inline-flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-md text-gray-700 text-sm font-medium cursor-pointer hover:bg-gray-50 transition-colors shadow-sm"
      (click)="openCreateUserModal()">
      <span class="text-lg">+</span> Crear nuevo usuario
    </button>
  </div>

  <div class="bg-white rounded-lg shadow-sm overflow-hidden mb-4">
    <table class="w-full border-collapse">
      <thead class="bg-gray-200">
        <tr>
          <th class="px-6 py-3 text-left text-sm font-semibold text-gray-900">Usuario</th>
          <th class="px-6 py-3 text-left text-sm font-semibold text-gray-900">Email</th>
          <th class="px-6 py-3 text-left text-sm font-semibold text-gray-900">Extensión</th>
          <th class="px-6 py-3 text-left text-sm font-semibold text-gray-900">Teléfono</th>
          <th class="px-6 py-3 text-left text-sm font-semibold text-gray-900">Agente</th>
          <th class="px-6 py-3 text-left text-sm font-semibold text-gray-900">Responsable</th>
          @if (isCurrentUserAdmin()) {
          <th class="px-6 py-3 text-center text-sm font-semibold text-gray-900">Admin</th>
          }
          <th class="px-6 py-3 text-left text-sm font-semibold text-gray-900">Acciones</th>
        </tr>
      </thead>
      <tbody class="bg-white divide-y divide-gray-200">
        @for (user of users; track user.id; let i = $index) {
        <tr class="hover:bg-gray-50 transition-colors">
          <td class="px-6 py-4 text-sm font-medium text-gray-900">
            @if (editingIndex !== i) {
            <span>{{ user.name }}</span>
            } @else {
            <input [(ngModel)]="user.name" type="text"
              class="px-3 py-2 border border-gray-300 rounded-md bg-white text-sm text-gray-900 w-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
            }
          </td>
          <td class="px-6 py-4 text-sm text-gray-500">
            @if (editingIndex !== i) {
            <span>{{ user.email }}</span>
            } @else {
            <input [(ngModel)]="user.email" type="email"
              class="px-3 py-2 border border-gray-300 rounded-md bg-white text-sm text-gray-900 w-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
            }
          </td>
          <td class="px-6 py-4 text-sm text-gray-900">
            @if (editingIndex !== i) {
            <span>{{ user.exten }}</span>
            } @else {
            <input [(ngModel)]="user.exten" type="text"
              class="px-3 py-2 border border-gray-300 rounded-md bg-white text-sm text-gray-900 w-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
            }
          </td>
          <td class="px-6 py-4 text-sm text-gray-900">
            @if (editingIndex !== i) {
            <span>{{ user.phone }}</span>
            } @else {
            <input [(ngModel)]="user.phone" type="tel"
              class="px-3 py-2 border border-gray-300 rounded-md bg-white text-sm text-gray-900 w-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
            }
          </td>
          <td class="px-6 py-4 text-sm">
            @if (editingIndex !== i) {
            <span>
              @if (user.job_title?.name === 'SDR') {
              <span
                class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                SDR
              </span>
              }
              @if (user.job_title?.name === 'Comercial') {
              <span
                class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
                Comercial
              </span>
              }
              @if (user.job_title?.name === 'CSM') {
              <span
                class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-orange-100 text-orange-800">
                CSM
              </span>
              }
            </span>
            } @else {
            <select [(ngModel)]="user.job_title_id"
              class="px-3 py-2 pr-8 border border-gray-300 rounded-md bg-white text-sm text-gray-900 cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
              <option [ngValue]="1">SDR</option>
              <option [ngValue]="2">Comercial</option>
            </select>
            }
          </td>
          <td class="px-6 py-4 text-sm">
            @if (editingIndex !== i) {
            <div class="flex items-center gap-2">
              @if (user.manager_id) {
              <span class="text-gray-900">{{ getResponsableName(user.manager_id) }}</span>
              } @else {
              <span
                class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-700">
                <svg class="w-3 h-3 mr-0.5" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd"
                    d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clip-rule="evenodd" />
                </svg>
                Responsable
              </span>
              }
            </div>
            } @else {
            <div class="flex items-center gap-2">
              <select [(ngModel)]="user.manager_id" [compareWith]="compareResponsable"
                class="px-3 py-2 pr-8 border border-gray-300 rounded-md bg-white text-sm text-gray-900 cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                <option [ngValue]="null">Es responsable</option>
                @for (resp of getResponsables(); track resp.id) {
                <option [ngValue]="resp.id">{{ resp.name }}</option>
                }
              </select>
            </div>
            }
          </td>
          @if (isCurrentUserAdmin()) {
          <td class="px-6 py-4 text-sm">
            <div class="flex items-center justify-center">
              <label class="inline-flex items-center cursor-pointer">
                <input type="checkbox" [checked]="user.is_superadmin" (click)="toggleAdmin(user, $event)"
                  class="sr-only peer">
                <div
                  class="relative w-8 h-4 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-px after:start-px after:bg-white after:border-gray-300 after:border after:rounded-full after:h-3.5 after:w-3.5 after:transition-all peer-checked:bg-blue-600">
                </div>
              </label>
            </div>
          </td>
          }
          <td class="px-6 py-4 text-sm">
            <div class="flex items-center gap-3">
              @if (editingIndex !== i) {
              <button (click)="editUser(i)" class="text-gray-400 hover:text-gray-600 transition-colors cursor-pointer"
                title="Editar">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
              </button>
              }
              @if (editingIndex === i) {
              <button (click)="saveUser()" class="text-green-500 hover:text-green-600 transition-colors cursor-pointer"
                title="Guardar">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
              </button>
              <button (click)="cancelEdit()" class="text-gray-400 hover:text-gray-600 transition-colors cursor-pointer"
                title="Cancelar">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
              }
              @if (editingIndex !== i) {
              <button (click)="deleteUser(i)" class="text-red-400 hover:text-red-600 transition-colors cursor-pointer"
                title="Eliminar">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
              </button>
              }
            </div>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
</div>

<!-- Modal crear usuario -->
<app-modal-create-user [isOpen]="showCreateUserModal" [responsables]="users" (create)="createUser($event)"
  (cancel)="closeCreateUserModal()"></app-modal-create-user>

<!-- Modales reutilizables -->
<app-modal-message [isOpen]="showMessageModal" [title]="messageModalTitle" [message]="messageModalMessage"
  [type]="messageModalType" (close)="closeMessageModal()"></app-modal-message>

<app-modal-confirm [isOpen]="showConfirmModal" [title]="confirmModalTitle" [message]="confirmModalMessage"
  [type]="confirmModalType" [buttons]="confirmButtons" (action)="onConfirmAction($event)">
</app-modal-confirm>